import { cloneElement } from 'react';
import { Button } from '@mui/material';
import './CardAction.scss';
import CustomTooltip from './CustomTooltip';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * Action of the lesson card
 *
 * @param {*} prop
 * - icon the icon to display on the lesson card
 * - label to display on the lesson card
 * - actionHandler action handler
 * - additional class
 */
const defaultProps = {
  icon: null,
  className: '',
  label: null,
  title: '',
  ariaLabel: '',
  disabled: false,
};

export default function CardAction(props) {
  const {
    icon,
    label,
    actionHandler,
    className,
    title,
    ariaLabel,
    disabled,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const buttonAction = label ? <Button onClick={actionHandler} className={`card-action ${className}`} size='small' variant='contained' startIcon={icon} disabled={disabled} {...rest}>{label}</Button>
    : (
      cloneElement(
        icon,
        {
          onClick: (e) => { e.stopPropagation(); actionHandler(e); },
          onKeyDown: (e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); actionHandler(e); } },
          className: `card-action icon-hover ${className}`,
          disabled,
          'aria-hidden': disabled ? 'true' : 'false',
          tabIndex: disabled ? -1 : 0,
          ...rest,
        },
      )
    );
  return (
    <CustomTooltip className='action-button-tooltip' title={title} aria-label={ariaLabel}>
      <>
        {buttonAction}
        {disabled && <span />}
      </>
    </CustomTooltip>
  );
}
